export default {
  items: [
"Afghan",
"American",
"Anglo-Indian",
"Arab, nfd",
"Argentinian",
"Australian",
"Australian Aboriginal and Torres Strait Islander",
"Australian South Sea Islander",
"Belgian",
"Brazilian",
"Burmese",
"Burundian",
"Canadian",
"Chilean",
"Chinese",
"Croatian",
"Czech",
"Danish",
"Dutch",
"Egyptian",
"English",
"Ethiopian",
"Filipino",
"Finnish",
"French",
"German",
"Greek",
"Hazara",
"Hungarian",
"Indian",
"Indonesian",
"Iranian",
"Iraqi",
"Irish",
"Italian",
"Japanese",
"Jewish",
"Karen",
"Khmer (Cambodian)",
"Korean",
"Latvian",
"Lebanese",
"Lithuanian",
"Macedonian",
"Malay",
"Maltese",
"Maori",
"Mauritian",
"Nepalese",
"New Zealander",
"Norwegian",
"Pakistani",
"Palestinian",
"Papua New Guinean",
"Polish",
"Portuguese",
"Romanian",
"Russian",
"Salvadoran",
"Samoan",
"Scottish",
"Serbian",
"Singaporean",
"Sinhalese",
"Slovene",
"Somali",
"South African",
"Spanish",
"Sri Lankan",
"Sudanese",
"Swedish",
"Swiss",
"Tamil, nfd",
"Thai",
"Timorese",
"Turkish",
"Ukrainian",
"Vietnamese",
"Welsh",
"Zimbabwean"
  ],
};



// WEBPACK FOOTER //
// ../data/wa/ancestry.js